<template>
    <div class="confirm-code" :class="[confirmClass, align, borderClass]">
        <input
            v-for="input in form.code"
            :key="input.id"
            v-model="input.value"
            v-confirm-input
            type="text"
            maxlength="1"
            aria-selected="false"
        />
    </div>
</template>

<script>
	export default {
		name: 'ui-confirm-code',

		directives: {
			confirmInput: {
				bind(el) {
					el.addEventListener('keydown', (event) => {
						const next = el.nextElementSibling
						const previous = el.previousElementSibling

						if (el.value) {
							if (event.key != 'Backspace' && next) next.focus()
						} else {
							if (event.key == 'Backspace' && previous) previous.focus()
						}
					})
					el.removeEventListener('keydown', null)
				},
			},
		},

		components: {
		},

		props: {
			value: {
				type: String,
				default: '',
			},

			name: {
				type: String,
				default: '',
			},

			size: {
				type: Number,
				default: 5,
			},

			correct: {
				type: Boolean,
				default: false,
			},

			align: {
				type: String,
				default: 'center'
			},

			border: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				form: {
					code: [],
				},
			}
		},

		computed: {
			confirmCode() {
				return this.form.code.map((item) => item.value).join('')
			},

			clearEventName() {
				return 'clear-confirm-code'
			},

			confirmClass() {
				return {
					correct: this.correct,
				}
			},

			borderClass(){
				return this.border ? 'border' : ''
			}
		},

		watch: {
			confirmCode(newValue) {
				this.$emit('input', newValue)
			},

			size(newSize) {
				this.form.code = [...this.makeInputs(newSize)]
			},
		},

		created() {
			this.$root.$on(this.clearEventName, () => {
				this.form.code = this.form.code.map((input) => ({
					id: input.id,
					value: '',
				}))
			})
		},

		destroyed() {
			this.$root.$off(this.clearEventName)
		},

		mounted() {
			this.form.code = [...this.makeInputs(this.size)]
		},

		methods: {
			makeInputs(size) {
				const inputs = []
				while (inputs.length < size) {
					inputs.push({
						id: inputs.length + 1,
						value: '',
					})
				}
				return inputs
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl';
</style>
